// src/services/accountService/fsCategoryService.ts
import {BASE_ACCOUNT_API, fetchAPI} from '@/services/api';

export interface FsCategory {
    fsId?: number;
    parentId?: number | null;
    level?: number;
    code?: string;
    nameEn?: string;
    nameZh?: string;
    statement?: string;
    /** Dr / Cr — 用于 Tiny Mode 转移同向过滤 */
    entry?: string | null;
    scheduleName?: string;
    isHeader?: number;
    isCalc?: number; // 0/1
    calcKey?: string;
    isLinkAfs?: number; // 0/1
    isActive?: number; // 0/1
    isDel?: number; // 0/1
    sortOrder?: number;
    children?: FsCategory[];
}

export interface FsCategoryPage {
    code?: string;
    nameEn?: string;
    nameZh?: string;
    statement?: string;
    page?: number;
    size?: number;
}

const base = BASE_ACCOUNT_API + '/fs-category';

export async function getCategory(id: number) {
    return fetchAPI<FsCategory>(`${base}/get?id=${id}`, {
        method: 'GET',
    });
}

export async function listAll() {
    return fetchAPI<FsCategory[]>(`${base}/list`, {
        method: 'GET',
    });
}

export async function getCategoryTree(category: FsCategoryPage) {
    return fetchAPI<FsCategory[] | { items: FsCategory[]; total: number }>(
        `${base}/queryTree`, {
            method: 'POST',
            body: JSON.stringify(category),
        });
}

export async function queryRemoveRootTreeByStatement(statement: string) {
    return fetchAPI<FsCategory[]>(
        `${base}/queryRemoveRootTreeByStatement/${statement}`, {
            method: 'POST'
        }
    )
}

export async function listCategories(category: FsCategoryPage) {
    return fetchAPI<FsCategory[] | { items: FsCategory[]; total: number }>(
        `${base}/queryPageTree`, {
            method: 'POST',
            body: JSON.stringify(category),
        });
}

export async function queryFsCategorySelection() {
    return fetchAPI<Record<string, string>>(`${base}/queryFsCategorySelection`, {
        method: 'POST',
    });
}

export async function createCategory(vo: FsCategory) {
    return fetchAPI<FsCategory>(`${base}/create`, {
        method: 'POST',
        body: JSON.stringify(vo),
    });
}

export async function updateCategory(id: number, vo: FsCategory) {
    return fetchAPI<FsCategory>(`${base}/update/${id}`, {
        method: 'POST',
        body: JSON.stringify(vo),
    });
}

export async function deleteCategory(id: number) {
    return fetchAPI<void>(`${base}/delete/${id}`, {method: 'POST'});
}

export interface ReorderItem {
    fsId: number;
    sortOrder: number;
}

export async function reorderCategories(items: ReorderItem[]) {
    return fetchAPI<void>(`${base}/reorder`, {
        method: 'POST',
        body: JSON.stringify({ items }),
    });
}
